var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOrganisation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u041E\\u0440\\u0433\\u0430\\u043D\\u0438\\u0437\\u0430\\u0446\\u0438\\u0438",
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.956,
    height: 14.956,
    viewBox: "0 0 14.956 14.956",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1687",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1687",
    d: "M226,390h1.753v3.564H226Z",
    transform: "translate(-219.398 -378.608)",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1688",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1688",
    d: "M121.023,14.956h2.19v-4.44h3.505v4.44h2.2V0h-7.9Zm6.134-13.2h.876v.876h-.876Zm0,1.753h.876v.876h-.876Zm0,1.753h.876v.876h-.876Zm0,1.753h.876v.876h-.876Zm0,1.753h.876V9.64h-.876ZM125.4,1.753h.876v.876H125.4Zm0,1.753h.876v.876H125.4Zm0,1.753h.876v.876H125.4Zm0,1.753h.876v.876H125.4Zm0,1.753h.876V9.64H125.4Zm-1.753-7.011h.876v.876h-.876Zm0,1.753h.876v.876h-.876Zm0,1.753h.876v.876h-.876Zm0,1.753h.876v.876h-.876Zm0,1.753h.876V9.64h-.876ZM121.9,1.753h.876v.876H121.9Zm0,1.753h.876v.876H121.9Zm0,1.753h.876v.876H121.9Zm0,1.753h.876v.876H121.9Zm0,1.753h.876V9.64H121.9Z",
    transform: "translate(-117.488)",
    fill: "current"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1689",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1689",
    d: "M420.637,120h2.669v11.451h-2.669Z",
    transform: "translate(-408.35 -116.495)",
    fill: "current"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1690",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1690",
    d: "M0,120H2.658v11.451H0Z",
    transform: "translate(0 -116.495)",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrganisation);
export default __webpack_public_path__ + "static/media/Organisation.e3e387c7b2c33f0205f4bc07edaafa5e.svg";
export { ForwardRef as ReactComponent };